export const formatDisplayNumber = (number, scale = 2, percent = false) => {
  try {
    if (number.toString() !== null && number !== undefined && number.toString() !== '0') {
      let args = number.toFixed(scale).toString().split('.')
      let decimal
      if (args.length > 1) {
        const decLength = args[1].length
        if (decLength < scale) {
          decimal = String.prototype.padEnd((scale - decLength), '0')
          args[1] = args[1] + decimal
        }
      } else {
        // Blank || white space || undefined
        if (args[0] === undefined || args[0] === '') {
          args[0] = '0'
        }
        decimal = String.prototype.padEnd(scale, '0')
        args.push(decimal)
      }
      if (!percent) {
        args[0] = args[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }

      return args.join('.')
    }
    return number.toFixed(scale).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  } catch (err) {
    return number
  }
}

export const removeFormatNumber = (str) => {
  if (str !== null && str !== undefined) {
    if (isNum(str)) {
      // If its already a number, return it
      return str
    } else {
      return str.replace(/\,/g, '')
    }
  } else {
    return str
  }
}

export function isInt(value) {
  if (isNaN(value)) {
    return false
  }
  var x = parseFloat(value)
  return (x | 0) === x
}

export function isNum(value) {
  return !isNaN(value)
}
